export default __webpack_public_path__ + "static/media/blueInformationIcon.80e3831a.svg";